<template>
  <div class="inpfile">
    <!-- 领券活动 -->
    <div v-if="atvType === 1" class="act-1">
      <div class="inp-box">
        <input
          @input="inpForm('phone')"
          v-model="params.phone"
          type="number"
          placeholder="请输入手机号"
        >
      </div>
      <div class="inp-line">
        <div class="inp-box">
          <input
            @input="inpForm('code')"
            v-model="params.code"
            type="number"
            placeholder="请输入验证码"
          >
        </div>
        <div @click="getMsgCode" :style="{ backgroundColor: extend.codeBtn }" class="code-btn">
          <span v-if="timer > 0">{{ timer }}s</span>
          <span v-else>获取验证码</span>
        </div>
      </div>
      <van-button
        @click="getTicket"
        :style="{ backgroundColor: extend.btnColor }"
        block
        class="foot-btn"
      >
        立即领取
      </van-button>
    </div>
    <!-- 抽奖活动 -->
    <div v-if="atvType === 2" :class="['act-2', brand]">
      <div class="ttl">
        <span v-if="brand === 'himo'">海马体账户</span>
        <span v-if="brand === 'family'">Family 账户</span>
      </div>
      <div class="inp-box">
        <input v-model="params.phone" type="number" placeholder="请输入手机号">
      </div>
      <div class="inp-box code">
        <input v-model="params.code" type="number" placeholder="请输入验证码">
        <div @click="getMsgCode" class="code-btn">
          <span v-if="timer > 0">{{ timer }}s</span>
          <span v-else>获取验证码</span>
        </div>
      </div>
      <van-button @click="getTicket" class="line-btn" block>登录</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import * as apis from '../../api/index'
// - 工具
import { mapState } from 'vuex'
import { gyValidate } from '@/api/common/index.js'
export default {
  props: {
    extend: {
      type: Object,
      default: () => {
        return {}
      }
    },
    atvType: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      params: {
        phone: '',
        code: '',
        token: ''
      },
      tencentPms: {
        captchaId: '2098376281',
        ticket: '',
        randStr: ''
      },
      timer: 0,
      pluginTokenLimit: 0
    }
  },
  computed: {
    ...mapState({
      brand: state => state.params.app_name,
      captchaInfo: state => state.captchaInfo
    })
  },
  methods: {
    inpForm (e) {
      let str = this.params[e]
      str = str.replace(/[^0-9|.]/ig, '')
      if (e === 'phone' && str.length > 11) {
        str = str.substr(0, 11)
      }
      if (e === 'code' && str.length > 6) {
        str = str.substr(0, 6)
      }
      this.params[e] = str
    },
    subFirm () {
      const ptn_phone = /^1[0-9]{10}$/
      const ptn_code = /[0-9]{6}/
      if (!ptn_phone.test(this.params.phone)) {
        Toast('请输入正确的手机号！')
        return false
      }
      if (!ptn_code.test(this.params.code)) {
        Toast('验证码格式不正确！')
        return false
      }
      return this.params
    },
    getMsgCode () {
      if (this.timer > 0) return
      const pattern = /^1[0-9]{10}$/
      if (!pattern.test(this.params.phone)) {
        Toast('请输入正确的手机号！')
        return
      }
      this.$toast.loading({
        message: '加载中',
        forbidClick: true,
        duration: 0
      })
      this.pluginToken()
    },
    async pluginToken () {
      try {
        // 确认插件是否加载完成
        if (JSON.stringify(this.captchaInfo) === '{}' && this.pluginTokenLimit < 30) {
          setTimeout(() => {
            this.pluginTokenLimit = this.pluginTokenLimit + 1
            this.pluginToken()
          }, 500)
          return
        } else if (this.pluginTokenLimit >= 30) {
          // 等待完成后 插件还未加载完成 重新执行初始化操作
          await this.$store.dispatch('initPlugin')

          if (JSON.stringify(this.captchaInfo) === '{}') {
            this.$toast.clear()
            this.$toast('您的网络异常，请稍后再试～')
            return
          }
          // 处理初始化完成后 执行verify无效的问题
          await new Promise((resolve, reject) => {
            setTimeout(() => resolve(true), 1000)
          })
        }
        this.pluginTokenLimit = 0
        await this.captchaInfo.verify()
        this.$toast.clear()
        this.captchaInfo.onSuccess(async () => {
          const result = this.captchaInfo.getValidate()
          const response = await gyValidate({
            geeTestChallenge: result.geetest_challenge,
            geeTestValidate: result.geetest_validate,
            geeTestSecCode: result.geetest_seccode,
            phone: this.params.phone
          })
          if (!response.msg) {
            this.$store.dispatch('initPlugin')
            this.$toast('验证失败，请稍后点击重试～')
            return
          }
          this.params.token = response.msg.token
          this.$store.commit('SET_CODE_TOKEN', response.msg.token)
          this.checkCode()
        })
      } catch (error) {
        this.$toast.clear()
        console.log(error, '----error----')
        this.$toast('您的网络异常，请稍后再试～')
      }
    },
    checkCode () {
      apis.getMsgCode({
        type: 'haimati_sms_code',
        token: this.params.token,
        phone: this.params.phone
      }).then(() => {
        this.timerSet()
      })
    },
    timerSet () {
      clearInterval(this.wait)
      this.timer = 60
      this.wait = setInterval(() => {
        if (this.timer > 0) this.timer--
      }, 1000)
    },
    getTicket () {
      this.$emit('getTicket')
    }
  }
}
</script>

<style lang="less" scoped>

.inpfile {
  .inp-box {
    position: relative;
    height: 42px;
    overflow: hidden;

    input {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      padding: 0 20px;
      font-size: 14px;
      color: #999;
      background: white;
      border: none;
      outline: none;
    }
  }

  .foot-btn {
    height: 42px;
    margin-top: 20px;
    line-height: 42px;
    color: white;
    text-align: center;
    border: none;
    border-radius: 6px;
    outline: none;
  }

  .himo {
    .ttl {
      color: #1a7785;
    }

    .code-btn {
      color: #1a7785;
    }
  }

  .family {
    .ttl {
      color: #f69439;
    }

    .code-btn {
      color: #f69439;
    }
  }

  .act-1 {
    // padding: 20px;
    position: relative;

    .inp-box {
      border-radius: 4px;

      input {
        text-align: center;
      }
    }

    .inp-line {
      display: flex;
      margin-top: 20px;

      .inp-box {
        flex-grow: 1;
        margin-right: 10px;
      }

      .code-btn {
        flex-shrink: 0;
        width: 120px;
        height: 42px;
        font-size: 14px;
        line-height: 42px;
        color: white;
        text-align: center;
        border-radius: 4px;
      }
    }

    .line-btn {
      border-radius: 4px;
    }
  }

  .act-2 {
    .ttl {
      margin-bottom: 30px;
      font-size: 16px;
      font-weight: bold;
      line-height: 16px;
      text-align: center;
    }

    .inp-box {
      border: 1px solid #e1e1e1;
      border-radius: 42px;
    }

    .code {
      display: flex;
      margin-top: 20px;

      input {
        flex-grow: 1;
        margin-right: 20px;
      }

      .code-btn {
        flex-shrink: 0;
        width: 120px;
        height: 40px;
        font-size: 14px;
        line-height: 40px;
        text-align: center;
      }
    }

    .line-btn {
      margin-top: 20px;
    }
  }
}

</style>
